/*
 * @Author: chengxian.wang
 * @Date: 2021-05-19 14:39:29
 * @LastEditors: xuhongwei
 * @LastEditTime: 2021-05-27 11:47:57
 */
import Vue from "vue";

export default {
  namespaced: true,
  state() {
    return {
      teacherMta: "wlxy_gdsd_kfgdsd_qrkf", // 交易时间
      content: {}, // 选中将要关闭的时间段
      teach_id: "",
      counted: 0, //选中关闭的时间数量，
      attendContent: {},
      updateLessons: {},
      initLessons: {},
      selectArrCount: 0
    };
  },
  mutations: {
    getCloseData(state: any, contents: any) {
      state.content = contents;
    },
    saveTeacherId(state: any, id: string) {
      state.teach_id = id;
    },
    getCounted(state: any, counted: number) {
      state.counted = counted;
    },
    getattendContent(state: any, attendContent: number) {
      state.attendContent = attendContent;
    },
    getupdateLessons(state: any, updateLessons: number) {
      state.updateLessons = updateLessons;
    },
    getinitLessons(state: any, initLessons: number) {
      state.initLessons = initLessons;
    },
    getselectArrCount(state: any, count: number) {
      state.selectArrCount = count;
    }
  }
};
